const robotData = [
  {
    "userName": "attackfrog",
    "teamName": "Aquatic Robotics",
    "robotName": "Pinstripe",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/0wVmcHX.png",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "14",
    "armor": "7 (+1 plow)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007099&t=9029427"
  },
  {
    "userName": "attackfrog",
    "teamName": "Aquatic Robotics",
    "robotName": "The Maw",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/bHx4IpG.png",
    "speed": "7",
    "traction": "5",
    "torque": "3",
    "weapon": "5",
    "armor": "10 (+1 plow)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007099&t=9029427"
  },
  {
    "userName": "attackfrog",
    "teamName": "Aquatic Robotics",
    "robotName": "Sinmill",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/9hW7zdm.png",
    "speed": "4",
    "traction": "2",
    "torque": "1",
    "weapon": "15",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007099&t=9029427"
  },
  {
    "userName": "attackfrog",
    "teamName": "Aquatic Robotics",
    "robotName": "Speed Bison",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/YQdgCgP.png",
    "speed": "7",
    "traction": "6",
    "torque": "3",
    "weapon": "2",
    "armor": "12 (+1 plow/fork)",
    "altConfig": "Fork/Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007099&t=9029427"
  },
  {
    "userName": "That Kode Guy",
    "teamName": "Team Covenant",
    "robotName": "Anti-Virus",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/qBUBOxH.png",
    "speed": "8",
    "traction": "8",
    "torque": "4",
    "weapon": "LOL",
    "armor": "10 (+2 plow)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007071&t=9029427"
  },
  {
    "userName": "That Kode Guy",
    "teamName": "Team Covenant",
    "robotName": "Plata O Plomo",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/lJY2MRH.png",
    "speed": "5",
    "traction": "5",
    "torque": "2",
    "weapon": "9",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007071&t=9029427"
  },
  {
    "userName": "That Kode Guy",
    "teamName": "Team Covenant",
    "robotName": "Devil's Verdict",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/Om38nXz.png",
    "speed": "4",
    "traction": "4",
    "torque": "1",
    "weapon": "1 (clamps) + 1 (arm) + 10 (saw)",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007071&t=9029427"
  },
  {
    "userName": "That Kode Guy",
    "teamName": "Team Covenant",
    "robotName": "Tax Cutter",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/ILHKYcE.png",
    "speed": "3",
    "traction": "2",
    "torque": "1",
    "weapon": "17",
    "armor": "7 (+1 weapon)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007071&t=9029427"
  },
  {
    "userName": "Shaba117",
    "teamName": "Team Stealth",
    "robotName": "The Thieving Magpie",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/t5FBRpi.png",
    "speed": "7",
    "traction": "6",
    "torque": "2",
    "weapon": "5",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007081&t=9029427"
  },
  {
    "userName": "Shaba117",
    "teamName": "Team Stealth",
    "robotName": "Harpy",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/a80SQwr.png",
    "speed": "8",
    "traction": "8",
    "torque": "3",
    "weapon": "0",
    "armor": "11(+1 plow)",
    "altConfig": "Spikes/Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007081&t=9029427"
  },
  {
    "userName": "Shaba117",
    "teamName": "Team Stealth",
    "robotName": "Death Metal",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/l7FdaxN.png",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "6",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007081&t=9029427"
  },
  {
    "userName": "Shaba117",
    "teamName": "Team Stealth",
    "robotName": "Triple 6",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/txCqCX5.png",
    "speed": "7",
    "traction": "6",
    "torque": "2",
    "weapon": "3",
    "armor": "12",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007081&t=9029427"
  },
  {
    "userName": "Cha0sFerret",
    "teamName": "Chaotic Robotics",
    "robotName": "Eat Me Too",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/EynRCV9.png",
    "speed": "15",
    "traction": "4",
    "torque": "1",
    "weapon": "0",
    "armor": "10 (+2 thwack head)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007082&t=9029427"
  },
  {
    "userName": "Cha0sFerret",
    "teamName": "Chaotic Robotics",
    "robotName": "Lulver",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/odITMLZ.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "13",
    "armor": "5",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007082&t=9029427"
  },
  {
    "userName": "Cha0sFerret",
    "teamName": "Chaotic Robotics",
    "robotName": "Wedgelord",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/83Ewkr9.png",
    "speed": "7",
    "traction": "7",
    "torque": "4",
    "weapon": "1",
    "armor": "11",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007082&t=9029427"
  },
  {
    "userName": "Cha0sFerret",
    "teamName": "Chaotic Robotics",
    "robotName": "Scrunglebot",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/IkoZN8S.png",
    "speed": "4",
    "traction": "1",
    "torque": "1",
    "weapon": "3 (arm) + 11 (saw)",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007082&t=9029427"
  },
  {
    "userName": "NWOWWE",
    "teamName": "Team Blood Gulch",
    "robotName": "Dr. Robotnik",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/uu0gMTk.jpg",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "6",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007079&t=9029427"
  },
  {
    "userName": "NWOWWE",
    "teamName": "Team Blood Gulch",
    "robotName": "Harbinger",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/9nfFGZN.png",
    "speed": "9",
    "traction": "8",
    "torque": "4",
    "weapon": "0",
    "armor": "9 (+2 plow)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007079&t=9029427"
  },
  {
    "userName": "NWOWWE",
    "teamName": "Team Blood Gulch",
    "robotName": "Redemption Denied",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/O1vy837.png",
    "speed": "7",
    "traction": "6",
    "torque": "2",
    "weapon": "6",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007079&t=9029427"
  },
  {
    "userName": "NWOWWE",
    "teamName": "Team Blood Gulch",
    "robotName": "Jack Frost",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/Mg6IT8p.png",
    "speed": "4",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007079&t=9029427"
  },
  {
    "userName": "patrickrowberry",
    "teamName": "Team Cardboard Pony",
    "robotName": "Ramshock",
    "weightClass": "Lightweight",
    "imageURL": "https://img00.deviantart.net/c511/i/2017/207/7/4/ramshock__new_robot__by_scorpion1m-dbhrunj.jpg",
    "speed": "7",
    "traction": "7",
    "torque": "3",
    "weapon": "5",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007080&t=9029427"
  },
  {
    "userName": "patrickrowberry",
    "teamName": "Team Cardboard Pony",
    "robotName": "Metal 2",
    "weightClass": "Middleweight",
    "imageURL": "https://pre00.deviantart.net/9ca8/th/pre/f/2015/345/d/9/metal_2___2nd_seed_and__2015world_champion__test_by_scorpion1m-d988200.jpg",
    "speed": "4",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007080&t=9029427"
  },
  {
    "userName": "patrickrowberry",
    "teamName": "Team Cardboard Pony",
    "robotName": "Mr. Bight Sky",
    "weightClass": "Heavyweight",
    "imageURL": "http://img02.deviantart.net/d6e4/i/2016/362/a/4/the_bright_side__13th_seed__by_scorpion1m-dat7887.jpg",
    "speed": "7",
    "traction": "5",
    "torque": "3",
    "weapon": "5",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007080&t=9029427"
  },
  {
    "userName": "patrickrowberry",
    "teamName": "Team Cardboard Pony",
    "robotName": "Death Turret 2000",
    "weightClass": "Superheavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/257918186203250688/343471888057630740/death_turret.png",
    "speed": "7",
    "traction": "5",
    "torque": "1",
    "weapon": "9 (5/5/5)",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007080&t=9029427"
  },
  {
    "userName": "Mole55",
    "teamName": "North-West Sheds",
    "robotName": "Witness Me",
    "weightClass": "Lightweight",
    "imageURL": "http://i.imgur.com/gZXD9Bp.png",
    "speed": "8",
    "traction": "8",
    "torque": "2",
    "weapon": "2",
    "armor": "10 armour (+1 flipper)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007085&t=9029427"
  },
  {
    "userName": "Mole55",
    "teamName": "North-West Sheds",
    "robotName": "Kid A",
    "weightClass": "Middleweight",
    "imageURL": "https://imgur.com/s6bG60X.png",
    "speed": "7",
    "traction": "5",
    "torque": "2",
    "weapon": "---",
    "armor": "4 (body)",
    "altConfig": "Drum: 11 Weapon / Clamp: 7(5/5) Weapon, +2 Armor bonus to top / Doorstop: +4 Armor bonus to wedge",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007085&t=9029427"
  },
  {
    "userName": "Mole55",
    "teamName": "North-West Sheds",
    "robotName": "Micro Cuts",
    "weightClass": "Heavyweight",
    "imageURL": "https://imgur.com/ToDclSf.png",
    "speed": "6",
    "traction": "4",
    "torque": "1",
    "weapon": "10 (1 arm)",
    "armor": "8 (+1 wedge)",
    "altConfig": "Forks/Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007085&t=9029427"
  },
  {
    "userName": "Mole55",
    "teamName": "North-West Sheds",
    "robotName": "Ikea's Guard Dog",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/8KepdeL.png",
    "speed": "8",
    "traction": "8",
    "torque": "4",
    "weapon": "1",
    "armor": "9 (+1 plow)",
    "altConfig": "Regular/Hammer Blocker",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007085&t=9029427"
  },
  {
    "userName": "The_Angry_Goat",
    "teamName": "Angry Goat Robotics",
    "robotName": "Nick's Fuzzy Rules",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/HadJJmP.jpg",
    "speed": "7",
    "traction": "6",
    "torque": "4",
    "weapon": "2 (arm) + 0(+1) (\"saw\")",
    "armor": "11",
    "altConfig": "Forks/Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007088&t=9029427"
  },
  {
    "userName": "The_Angry_Goat",
    "teamName": "Angry Goat Robotics",
    "robotName": "Glitch",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/p42Ht7L.jpg",
    "speed": "6",
    "traction": "4",
    "torque": "1",
    "weapon": "13 (weapon) + 1 (lifter)",
    "armor": "5",
    "altConfig": "Crusher/Vertical Spinner/Horizontal Spinner",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007088&t=9029427"
  },
  {
    "userName": "The_Angry_Goat",
    "teamName": "Angry Goat Robotics",
    "robotName": "Hazardous Waste Removal",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/X8BBQjB.jpg",
    "speed": "4",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "7 (+1 spinner)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007088&t=9029427"
  },
  {
    "userName": "The_Angry_Goat",
    "teamName": "Angry Goat Robotics",
    "robotName": "Khnum",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/wGPOf0N.png",
    "speed": "11",
    "traction": "5",
    "torque": "2",
    "weapon": "1",
    "armor": "11 (+2 front)",
    "altConfig": "Forked Lifter/Anti-Spinner Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007088&t=9029427"
  },
  {
    "userName": "Sylandrophol",
    "teamName": "Team Foxtrot Uniform",
    "robotName": "Mushroom Cloud",
    "weightClass": "Lightweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/368514845156573185/c7811354243cf631b40aa8a6e02182ee.png",
    "speed": "7",
    "traction": "6",
    "torque": "2",
    "weapon": "3",
    "armor": "12",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007090&t=9029427"
  },
  {
    "userName": "Sylandrophol",
    "teamName": "Team Foxtrot Uniform",
    "robotName": "Biological Warfare",
    "weightClass": "Middleweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/410588576905166861/743d6adca39079e433b187e513bc0d6a.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "8 (drum) + 1 (lifter)",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007090&t=9029427"
  },
  {
    "userName": "Sylandrophol",
    "teamName": "Team Foxtrot Uniform",
    "robotName": "America Offline",
    "weightClass": "Heavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/389172812595724298/e00cb2328891d5a61e2f32cd67aee1ea.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "8",
    "armor": "10 (+1 front wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007090&t=9029427"
  },
  {
    "userName": "Sylandrophol",
    "teamName": "Team Foxtrot Uniform",
    "robotName": "Space Cadet",
    "weightClass": "Superheavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/414561572950769667/f007f862f552a9480a14ddc1f1377af2.png",
    "speed": "7",
    "traction": "6",
    "torque": "3",
    "weapon": "2",
    "armor": "12 (+1 front wedges)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007090&t=9029427"
  },
  {
    "userName": "V900",
    "teamName": "End of the Line LLC",
    "robotName": "Cream",
    "weightClass": "Lightweight",
    "imageURL": "https://image.ibb.co/gxHtkx/ice_glow2.png",
    "speed": "16",
    "traction": "1",
    "torque": "1",
    "weapon": "1 (meltybrain movement)",
    "armor": "11",
    "altConfig": "Chains/Teeth",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007091&t=9029427"
  },
  {
    "userName": "V900",
    "teamName": "End of the Line LLC",
    "robotName": "Patchouli",
    "weightClass": "Middleweight",
    "imageURL": "https://image.ibb.co/mqbHdH/patch2_fullrender_0.png",
    "speed": "4",
    "traction": "1",
    "torque": "1",
    "weapon": "16 (spinner) / 11 (drum) / 13 (flipper)",
    "armor": "7 (spinner) / 12 (drum) / 10 (flipper)",
    "altConfig": "Spinner/Drum/Flipper",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007091&t=9029427"
  },
  {
    "userName": "V900",
    "teamName": "End of the Line LLC",
    "robotName": "Neglected Waterbug",
    "weightClass": "Heavyweight",
    "imageURL": "https://image.ibb.co/chMefn/nwb3tooth.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "5 (spinner) + 1 (flipper)",
    "armor": "12 (+2 front and diagonal edges)",
    "altConfig": "Removable Wedgelets",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007091&t=9029427"
  },
  {
    "userName": "V900",
    "teamName": "End of the Line LLC",
    "robotName": "BEEF KING",
    "weightClass": "Superheavyweight",
    "imageURL": "https://image.ibb.co/ctGdt7/beef.png",
    "speed": "3",
    "traction": "1",
    "torque": "1",
    "weapon": "17",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007091&t=9029427"
  },
  {
    "userName": "Wolf51-50",
    "teamName": "Alpha Robotics",
    "robotName": "White Lightning",
    "weightClass": "Lightweight",
    "imageURL": "http://imgur.com/wiy6XG9.png",
    "speed": "10",
    "traction": "8",
    "torque": "3",
    "weapon": "1",
    "armor": "8 (+2 plow)",
    "altConfig": "Plow/Thwack Tail/Neither",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007092&t=9029427"
  },
  {
    "userName": "Wolf51-50",
    "teamName": "Alpha Robotics",
    "robotName": "Diablo Genesis",
    "weightClass": "Middleweight",
    "imageURL": "https://cdn.discordapp.com/attachments/377264121227378690/399024732650995713/diablo.PNG",
    "speed": "7",
    "traction": "6",
    "torque": "3",
    "weapon": "4",
    "armor": "10 (+1 plow)",
    "altConfig": "Lifter/Flipper",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007092&t=9029427"
  },
  {
    "userName": "Wolf51-50",
    "teamName": "Alpha Robotics",
    "robotName": "Coup de Grâce",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/tY1p8yW.png",
    "speed": "5",
    "traction": "5",
    "torque": "1",
    "weapon": "12",
    "armor": "11",
    "altConfig": "Hammer/Flipper",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007092&t=9029427"
  },
  {
    "userName": "Wolf51-50",
    "teamName": "Alpha Robotics",
    "robotName": "Fenrir",
    "weightClass": "Superheavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/340154376909881344/401162639042019329/fenrir.png",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "6",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007092&t=9029427"
  },
  {
    "userName": "British-Robotics",
    "teamName": "Team TBR",
    "robotName": "Electric Agression",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/VFvynf4.jpg",
    "speed": "6",
    "traction": "6",
    "torque": "2",
    "weapon": "5 (3/3/3)",
    "armor": "11 (+1 rear wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007094&t=9029427"
  },
  {
    "userName": "British-Robotics",
    "teamName": "Team TBR",
    "robotName": "Instigator",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/AFhHARK.jpg",
    "speed": "8",
    "traction": "7",
    "torque": "3",
    "weapon": "2",
    "armor": "10 (+1 plow)",
    "altConfig": "Regular/Anti-spinner",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007094&t=9029427"
  },
  {
    "userName": "British-Robotics",
    "teamName": "Team TBR",
    "robotName": "Dysprosinator",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/uBrLtdy.png",
    "speed": "7",
    "traction": "6",
    "torque": "3",
    "weapon": "2",
    "armor": "12",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007094&t=9029427"
  },
  {
    "userName": "British-Robotics",
    "teamName": "Team TBR",
    "robotName": "Chemical Explosion 4",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/4DYogTQ.png?1",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "6",
    "altConfig": "Removable Wedge",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007094&t=9029427"
  },
  {
    "userName": "Hiicantpk",
    "teamName": "Team 57",
    "robotName": "Tidal Wave II",
    "weightClass": "Lightweight",
    "imageURL": "http://imgur.com/LbyYJkp.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "6",
    "altConfig": "Removable Shields",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007097&t=9029427"
  },
  {
    "userName": "Hiicantpk",
    "teamName": "Team 57",
    "robotName": "Remi IV",
    "weightClass": "Middleweight",
    "imageURL": "https://imgur.com/gjTRH3W.png",
    "speed": "4",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "7",
    "altConfig": "Removable Underscoop",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007097&t=9029427"
  },
  {
    "userName": "Hiicantpk",
    "teamName": "Team 57",
    "robotName": "Flandre Scarlett",
    "weightClass": "Heavyweight",
    "imageURL": "http://imgur.com/sXiTxLq.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007097&t=9029427"
  },
  {
    "userName": "Hiicantpk",
    "teamName": "Team 57",
    "robotName": "Lifter 2: Electric Boogaloo",
    "weightClass": "Superheavyweight",
    "imageURL": "https://imgur.com/3xjccbL.png",
    "speed": "6",
    "traction": "5",
    "torque": "3",
    "weapon": "3",
    "armor": "13",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007097&t=9029427"
  },
  {
    "userName": "Madman",
    "teamName": "Tartarus Robotics Group",
    "robotName": "Hoarfrost III",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/w5zJrlK.png",
    "speed": "8",
    "traction": "8",
    "torque": "3",
    "weapon": "0",
    "armor": "11 (+1 wedge)",
    "altConfig": "Removable Wedgelets",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007182&t=9029427"
  },
  {
    "userName": "Madman",
    "teamName": "Tartarus Robotics Group",
    "robotName": "Sundancer",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/nm7ifGA.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "12",
    "armor": "8 (+2 plow)",
    "altConfig": "Hammer/Flipper",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007182&t=9029427"
  },
  {
    "userName": "Madman",
    "teamName": "Tartarus Robotics Group",
    "robotName": "Meanstreak II",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/VESfctT.png",
    "speed": "8",
    "traction": "8",
    "torque": "2",
    "weapon": "5",
    "armor": "7 (+1 drum)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007182&t=9029427"
  },
  {
    "userName": "Madman",
    "teamName": "Tartarus Robotics Group",
    "robotName": "Krakatoa",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/iiq7HO0.png",
    "speed": "7",
    "traction": "7",
    "torque": "2",
    "weapon": "5 (3/3/3)",
    "armor": "10 (+1 lifter)",
    "altConfig": "Lifter&Flamer/Lifter-Plow",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007182&t=9029427"
  },
  {
    "userName": "GF93",
    "teamName": "Ice Cubed Robotics",
    "robotName": "Ayame",
    "weightClass": "Lightweight",
    "imageURL": "https://www.imageupload.co.uk/images/2018/02/06/ayrobot.png",
    "speed": "8",
    "traction": "7",
    "torque": "2",
    "weapon": "2",
    "armor": "11",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007183&t=9029427"
  },
  {
    "userName": "GF93",
    "teamName": "Ice Cubed Robotics",
    "robotName": "Marauder",
    "weightClass": "Middleweight",
    "imageURL": "https://www.imageupload.co.uk/images/2018/02/26/m3.png",
    "speed": "7",
    "traction": "7",
    "torque": "4",
    "weapon": "2",
    "armor": "10",
    "altConfig": "Flipper/Lifter",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007183&t=9029427"
  },
  {
    "userName": "GF93",
    "teamName": "Ice Cubed Robotics",
    "robotName": "Dreadnought Mk3",
    "weightClass": "Heavyweight",
    "imageURL": "https://www.imageupload.co.uk/images/2018/02/25/dreadnoughtmk33.jpg",
    "speed": "7",
    "traction": "6",
    "torque": "3",
    "weapon": "5",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007183&t=9029427"
  },
  {
    "userName": "GF93",
    "teamName": "Ice Cubed Robotics",
    "robotName": "Lethal Injection 3",
    "weightClass": "Superheavyweight",
    "imageURL": "https://www.imageupload.co.uk/images/2018/02/24/LI3.png",
    "speed": "6",
    "traction": "5",
    "torque": "3",
    "weapon": "5",
    "armor": "11",
    "altConfig": "Spiky Clamp/Anti-Spinner Clamp",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007183&t=9029427"
  },
  {
    "userName": "Hooray For Lexan",
    "teamName": "Team Instant Regret",
    "robotName": "Experiment 626",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/0VsymVM.jpg",
    "speed": "7",
    "traction": "7",
    "torque": "3",
    "weapon": "1",
    "armor": "12 (+1 front wedge)",
    "altConfig": "Wedgelets/Plow/Scoop",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007188&t=9029427"
  },
  {
    "userName": "Hooray For Lexan",
    "teamName": "Team Instant Regret",
    "robotName": "Clown Recluse",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/KEQtTpI.jpg",
    "speed": "4",
    "traction": "3",
    "torque": "1",
    "weapon": "14 (spinner) + 1 (rotation)",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007188&t=9029427"
  },
  {
    "userName": "Hooray For Lexan",
    "teamName": "Team Instant Regret",
    "robotName": "Charybdis",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/aNCcxhT.jpg",
    "speed": "16",
    "traction": "1",
    "torque": "1",
    "weapon": "2",
    "armor": "10 (+2 teeth)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007188&t=9029427"
  },
  {
    "userName": "Hooray For Lexan",
    "teamName": "Team Instant Regret",
    "robotName": "Danger Noodle",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/bXKHnva.jpg",
    "speed": "3",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007188&t=9029427"
  },
  {
    "userName": "Badnik96",
    "teamName": "Team Ignition",
    "robotName": "Flash Flood",
    "weightClass": "Lightweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/352952393501245441/flashflood_1.png",
    "speed": "8",
    "traction": "7",
    "torque": "3",
    "weapon": "1",
    "armor": "11 (+2 wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007294&t=9029427"
  },
  {
    "userName": "Badnik96",
    "teamName": "Team Ignition",
    "robotName": "WhipCoil",
    "weightClass": "Middleweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/353015015193837568/whipcoil8.png",
    "speed": "7",
    "traction": "7",
    "torque": "3",
    "weapon": "3 (2/2)",
    "armor": "10 (+2 plow/tongue)",
    "altConfig": "Rear Plow/Tongue",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007294&t=9029427"
  },
  {
    "userName": "Badnik96",
    "teamName": "Team Ignition",
    "robotName": "Malacoda",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/A4gh0HB.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "13",
    "armor": "7 (+2 forks)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007294&t=9029427"
  },
  {
    "userName": "Badnik96",
    "teamName": "Team Ignition",
    "robotName": "Phantasmic Slammer",
    "weightClass": "Superheavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/347914462927257602/slammer_blue.png",
    "speed": "8",
    "traction": "7",
    "torque": "2",
    "weapon": "2",
    "armor": "11 (+2 plow)",
    "altConfig": "Regular/Hammer Blocker",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007294&t=9029427"
  },
  {
    "userName": "The Monsterworks",
    "teamName": "The Monsterworks",
    "robotName": "La Valette",
    "weightClass": "Lightweight",
    "imageURL": "http://i.imgur.com/juPyyOP.png",
    "speed": "3",
    "traction": "1",
    "torque": "1",
    "weapon": "17",
    "armor": "8",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007295&t=9029427"
  },
  {
    "userName": "The Monsterworks",
    "teamName": "The Monsterworks",
    "robotName": "Magnolia Pico",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/qbb1dXh.png",
    "speed": "5",
    "traction": "5",
    "torque": "1",
    "weapon": "12",
    "armor": "11",
    "altConfig": "Hammer/Turret Flipper/Turret Clamp&Flamer",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007295&t=9029427"
  },
  {
    "userName": "The Monsterworks",
    "teamName": "The Monsterworks",
    "robotName": "Magnolia Grande",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/4qxGhNG.png",
    "speed": "4",
    "traction": "1",
    "torque": "1",
    "weapon": "17",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007295&t=9029427"
  },
  {
    "userName": "The Monsterworks",
    "teamName": "The Monsterworks",
    "robotName": "Howler III",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/JDF6tTE.png",
    "speed": "3",
    "traction": "1",
    "torque": "1",
    "weapon": "17",
    "armor": "8",
    "altConfig": "Vertical Spinner/Hammer",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007295&t=9029427"
  },
  {
    "userName": "Mystic2000",
    "teamName": "Team Myst Inc",
    "robotName": "Yellow Buzzard",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/AZpCUKb.png",
    "speed": "7",
    "traction": "5",
    "torque": "3",
    "weapon": "4",
    "armor": "11",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007416&t=9029427"
  },
  {
    "userName": "Mystic2000",
    "teamName": "Team Myst Inc",
    "robotName": "Heaven Jaws 3",
    "weightClass": "Middleweight",
    "imageURL": "https://media.discordapp.net/attachments/192687201333542912/415191862522019841/unknown.png?width=298&height=300",
    "speed": "6",
    "traction": "3",
    "torque": "1",
    "weapon": "13",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007416&t=9029427"
  },
  {
    "userName": "Mystic2000",
    "teamName": "Team Myst Inc",
    "robotName": "Golden Blaze",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/sLmI1Vj.png",
    "speed": "4",
    "traction": "3",
    "torque": "1",
    "weapon": "15",
    "armor": "7 (+1 spinner)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007416&t=9029427"
  },
  {
    "userName": "Mystic2000",
    "teamName": "Team Myst Inc",
    "robotName": "Xonotic",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/wrAallI.png",
    "speed": "8",
    "traction": "7",
    "torque": "2",
    "weapon": "4",
    "armor": "9 (+2 wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007416&t=9029427"
  },
  {
    "userName": "NeonCalypso",
    "teamName": "PMD:CR",
    "robotName": "Sir Morphsalot",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/b11HerF.png",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "14",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007525&t=9029427"
  },
  {
    "userName": "NeonCalypso",
    "teamName": "PMD:CR",
    "robotName": "Mole Butcher",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/OkpiflA.png",
    "speed": "6",
    "traction": "4",
    "torque": "4",
    "weapon": "7",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007525&t=9029427"
  },
  {
    "userName": "NeonCalypso",
    "teamName": "PMD:CR",
    "robotName": "Duck King",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/ozvo4cY.png",
    "speed": "8",
    "traction": "2",
    "torque": "6",
    "weapon": "4",
    "armor": "10 (+2 wedge)",
    "altConfig": "Rear or Front Hinge",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007525&t=9029427"
  },
  {
    "userName": "NeonCalypso",
    "teamName": "PMD:CR",
    "robotName": "Froral Fury",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/mk5P2vT.png",
    "speed": "16",
    "traction": "1",
    "torque": "1",
    "weapon": "3 (meltybrain movement)",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10007525&t=9029427"
  },
  {
    "userName": "BEES",
    "teamName": "Team Yellow Alert",
    "robotName": "Exotherm",
    "weightClass": "Lightweight",
    "imageURL": "http://i.imgur.com/cOqUwmFl.jpg",
    "speed": "7",
    "traction": "4",
    "torque": "1",
    "weapon": "13",
    "armor": "5",
    "altConfig": "Forks/Shield",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008211&t=9029427"
  },
  {
    "userName": "BEES",
    "teamName": "Team Yellow Alert",
    "robotName": "Stingray",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/EOQx9ikl.jpg",
    "speed": "9",
    "traction": "6",
    "torque": "3",
    "weapon": "4",
    "armor": "8",
    "altConfig": "Fun and Happy Attachments",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008211&t=9029427"
  },
  {
    "userName": "BEES",
    "teamName": "Team Yellow Alert",
    "robotName": "Infrared",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/nYCeK40l.jpg",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "13",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008211&t=9029427"
  },
  {
    "userName": "BEES",
    "teamName": "Team Yellow Alert",
    "robotName": "Metal Heck",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/7MLJ0Vv.jpg",
    "speed": "5",
    "traction": "3",
    "torque": "1",
    "weapon": "13 (spinner) + 1 (pivot)",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008211&t=9029427"
  },
  {
    "userName": "Avalanche",
    "teamName": "Ironside Industries",
    "robotName": "Blitz Mk. III",
    "weightClass": "Lightweight",
    "imageURL": "https://imgur.com/JDsO2MM.png",
    "speed": "6",
    "traction": "5",
    "torque": "3",
    "weapon": "8",
    "armor": "8 (+3 flipper)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008331&t=9029427"
  },
  {
    "userName": "Avalanche",
    "teamName": "Ironside Industries",
    "robotName": "Raus Mk. IV",
    "weightClass": "Middleweight",
    "imageURL": "https://imgur.com/RCLNefc.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "6",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008331&t=9029427"
  },
  {
    "userName": "Avalanche",
    "teamName": "Ironside Industries",
    "robotName": "Cutthroat",
    "weightClass": "Heavyweight",
    "imageURL": "https://imgur.com/pilg6RU.png",
    "speed": "6",
    "traction": "5",
    "torque": "5",
    "weapon": "5 (3/3)",
    "armor": "9 (+2 lifter)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008331&t=9029427"
  },
  {
    "userName": "Avalanche",
    "teamName": "Ironside Industries",
    "robotName": "Panzer Strike Mk. II",
    "weightClass": "Superheavyweight",
    "imageURL": "https://imgur.com/PLpxUss.png",
    "speed": "3",
    "traction": "2",
    "torque": "4",
    "weapon": "13",
    "armor": "8 (+2 plow)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008331&t=9029427"
  },
  {
    "userName": "GuldenFlame",
    "teamName": "Team Loading",
    "robotName": "Bluebot",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/oEIFhHN.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "13",
    "armor": "5",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008361&t=9029427"
  },
  {
    "userName": "GuldenFlame",
    "teamName": "Team Loading",
    "robotName": "Killing Intent",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/l1E5M2h.png",
    "speed": "6",
    "traction": "6",
    "torque": "2",
    "weapon": "2",
    "armor": "14 (+1 wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008361&t=9029427"
  },
  {
    "userName": "GuldenFlame",
    "teamName": "Team Loading",
    "robotName": "Flashback",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/KM4wt3H.png",
    "speed": "6",
    "traction": "5",
    "torque": "1",
    "weapon": "7 (spinner) + 1 (pivot)",
    "armor": "10 (+3 Wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008361&t=9029427"
  },
  {
    "userName": "GuldenFlame",
    "teamName": "Team Loading",
    "robotName": "Ravex",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/CaHN1t2.png",
    "speed": "5",
    "traction": "5",
    "torque": "3",
    "weapon": "5",
    "armor": "12",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10008361&t=9029427"
  },
  {
    "userName": "Trihunter",
    "teamName": "Team Trihunter",
    "robotName": "The Most Despicable and Disastrous Twins",
    "weightClass": "Lightweight",
    "imageURL": "https://cdn.discordapp.com/attachments/339154534850887680/415962214034571273/The_Most_Despicable_and_Disasterous_Twins.png",
    "speed": "J:12/S:4",
    "traction": "J:1/S:2",
    "torque": "J:1/S:2",
    "weapon": "J:1 / S:0",
    "armor": "J:7 / S:14",
    "altConfig": "Multibot: Joon & Shion",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10010903&t=9029427"
  },
  {
    "userName": "Trihunter",
    "teamName": "Team Trihunter",
    "robotName": "G.B.J.",
    "weightClass": "Middleweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/415638169732644884/GBJ.png",
    "speed": "7",
    "traction": "4",
    "torque": "1",
    "weapon": "6 (saw) + 2 (arm)",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10010903&t=9029427"
  },
  {
    "userName": "Trihunter",
    "teamName": "Team Trihunter",
    "robotName": "Lunatic Udonge",
    "weightClass": "Heavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/415640118557278229/Lunatic_Udonge_Flipper.png",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "8",
    "armor": "12 (+2 plow)",
    "altConfig": "Flipper/Axe",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10010903&t=9029427"
  },
  {
    "userName": "Trihunter",
    "teamName": "Team Trihunter",
    "robotName": "Hartmann's Youkai Bot",
    "weightClass": "Superheavyweight",
    "imageURL": "https://cdn.discordapp.com/attachments/192687201333542912/416321190714408960/Hartmanns_Youkai_Bot.png",
    "speed": "3",
    "traction": "1",
    "torque": "1",
    "weapon": "15 (spinner) + 1 (lifter)",
    "armor": "9 (+1 wedge)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10010903&t=9029427"
  },
  {
    "userName": "Jamied666",
    "teamName": "Team Edgy Robotics",
    "robotName": "Nervous Wedge Boy",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/3gh9v10.png",
    "speed": "7",
    "traction": "7",
    "torque": "4",
    "weapon": "0",
    "armor": "12",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012421&t=9029427"
  },
  {
    "userName": "Jamied666",
    "teamName": "Team Edgy Robotics",
    "robotName": "The Magpie Effect",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/cXb6pba.png",
    "speed": "7",
    "traction": "5",
    "torque": "1",
    "weapon": "13",
    "armor": "5 (+1 drum)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012421&t=9029427"
  },
  {
    "userName": "Jamied666",
    "teamName": "Team Edgy Robotics",
    "robotName": "Nyam Nyam Nya",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/lpsUueA.jpg",
    "speed": "6",
    "traction": "4",
    "torque": "2",
    "weapon": "10",
    "armor": "7",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012421&t=9029427"
  },
  {
    "userName": "Jamied666",
    "teamName": "Team Edgy Robotics",
    "robotName": "Needles 2.0",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/fFxLxC1.jpg",
    "speed": "5",
    "traction": "2",
    "torque": "1",
    "weapon": "12",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012421&t=9029427"
  },
  {
    "userName": "PyroTechnica",
    "teamName": "ARSONIST Inc.",
    "robotName": "HIRricaine",
    "weightClass": "Lightweight",
    "imageURL": "http://i.imgur.com/jwEug8e.jpg",
    "speed": "4",
    "traction": "1",
    "torque": "1",
    "weapon": "15",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012505&t=9029427"
  },
  {
    "userName": "PyroTechnica",
    "teamName": "ARSONIST Inc.",
    "robotName": "Magica",
    "weightClass": "Middleweight",
    "imageURL": "http://i.imgur.com/oJmrACa.jpg",
    "speed": "8",
    "traction": "7",
    "torque": "2",
    "weapon": "3",
    "armor": "10 (+1 flipper)",
    "altConfig": "Optional Anti-Hammer Plate",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012505&t=9029427"
  },
  {
    "userName": "PyroTechnica",
    "teamName": "ARSONIST Inc.",
    "robotName": "Narsiccistic Hot-Shot",
    "weightClass": "Heavyweight",
    "imageURL": "http://i.imgur.com/MJ5RzG4.jpg",
    "speed": "5",
    "traction": "4",
    "torque": "1",
    "weapon": "10",
    "armor": "10",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012505&t=9029427"
  },
  {
    "userName": "PyroTechnica",
    "teamName": "ARSONIST Inc.",
    "robotName": "Cyclone",
    "weightClass": "Superheavyweight",
    "imageURL": "http://i.imgur.com/rGxrBBd.jpg",
    "speed": "3",
    "traction": "1",
    "torque": "1",
    "weapon": "14 (spinner) + 1 (gearbox)",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012505&t=9029427"
  },
  {
    "userName": "prince palatine",
    "teamName": "Team Ectogasm",
    "robotName": "The Servant's Assistant 4",
    "weightClass": "Lightweight",
    "imageURL": "https://i.imgur.com/NN9BNv2.png",
    "speed": "7",
    "traction": "7",
    "torque": "3",
    "weapon": "2 (scoop) + 2 (axe)",
    "armor": "9",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012530&t=9029427"
  },
  {
    "userName": "prince palatine",
    "teamName": "Team Ectogasm",
    "robotName": "Lupi",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/xryzoH9.png",
    "speed": "4",
    "traction": "4",
    "torque": "1",
    "weapon": "14",
    "armor": "7",
    "altConfig": "Over-Under Blades/Hammerheads/Slopes",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012530&t=9029427"
  },
  {
    "userName": "prince palatine",
    "teamName": "Team Ectogasm",
    "robotName": "Klarinette 4",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/hMABHgg.png",
    "speed": "7",
    "traction": "7",
    "torque": "3",
    "weapon": "3",
    "armor": "10 (+1 lifter)",
    "altConfig": "",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012530&t=9029427"
  },
  {
    "userName": "prince palatine",
    "teamName": "Team Ectogasm",
    "robotName": "Parasoul",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/FMlVCcL.png",
    "speed": "8",
    "traction": "8",
    "torque": "4",
    "weapon": "0",
    "armor": "10 (+1 plow)",
    "altConfig": "Eurypterus/Reflector Shield/ABR",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012530&t=9029427"
  },
  {
    "userName": "(Various)",
    "teamName": "The Dream Team",
    "robotName": "Green Brick",
    "weightClass": "Lightweight",
    "imageURL": "https://cdn.discordapp.com/attachments/368076872245968898/417549203015860225/Mr.AS-AREYOUREADYTOLE.png",
    "speed": "11",
    "traction": "1",
    "torque": "3",
    "weapon": "0",
    "armor": "15",
    "altConfig": "(Mr. AS/V900)",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012661&t=9029427"
  },
  {
    "userName": "(Various)",
    "teamName": "The Dream Team",
    "robotName": "Eye of n00t",
    "weightClass": "Middleweight",
    "imageURL": "https://i.imgur.com/BE82PXW.png",
    "speed": "3",
    "traction": "2",
    "torque": "1",
    "weapon": "16",
    "armor": "8",
    "altConfig": "(Madman)",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012661&t=9029427"
  },
  {
    "userName": "(Various)",
    "teamName": "The Dream Team",
    "robotName": "Chad the Inhaler",
    "weightClass": "Heavyweight",
    "imageURL": "https://i.imgur.com/mmSphCy.png",
    "speed": "12",
    "traction": "10",
    "torque": "3",
    "weapon": "1",
    "armor": "4",
    "altConfig": "(The_Angry_Goat (🐐))",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012661&t=9029427"
  },
  {
    "userName": "(Various)",
    "teamName": "The Dream Team",
    "robotName": "Count Bleck",
    "weightClass": "Superheavyweight",
    "imageURL": "https://i.imgur.com/oyOtdXp.png",
    "speed": "1",
    "traction": "1",
    "torque": "1",
    "weapon": "20",
    "armor": "7",
    "altConfig": "(That Kode Guy)",
    "postURL": "http://s10.zetaboards.com/Drowning_City_Forums/single/?p=10012661&t=9029427"
  }
 ];

 export default robotData;


// WEBPACK FOOTER //
// ./src/data/robotData.js